import RecordsCadenceEffectivenessBand from "@app/types/dashboard/cards/recordsCadenceEffectiveness/RecordsCadenceEffectivenessBand";

export interface OverdueBandAggregates {
  /** Count of accounts with `cadenceDaysOut` in [30, 60). */
  band30: number;
  /** Count of accounts with `cadenceDaysOut` in [60, 90). */
  band60: number;
  /** Count of accounts with `cadenceDaysOut` >= 90. */
  band90: number;
  /** Cadence-configured, non-lead records in scope. */
  totalRecords: number;
}

export interface OverdueBands {
  /** Raw record count per band, keyed by the band's lower bound of `cadenceDaysOut`. */
  bands: Record<RecordsCadenceEffectivenessBand, number>;
  totalRecords: number;
}

/**
 * Shapes the raw "Records Overdue 30/60/90" counts into the store payload: the
 * per-band record counts plus the total record count. No percentages are computed here —
 * the store holds raw numbers only and the card computes each band's share at
 * render time. Returns `undefined` when there are no cadence-configured accounts
 * in scope so the card can render a "set up Frequencies" empty state.
 */
export const computeOverdueBands = ({
  band30,
  band60,
  band90,
  totalRecords,
}: OverdueBandAggregates): OverdueBands | undefined => {
  if (totalRecords <= 0) {
    return undefined;
  }

  return {
    bands: {
      [RecordsCadenceEffectivenessBand.NINETY]: band90,
      [RecordsCadenceEffectivenessBand.SIXTY]: band60,
      [RecordsCadenceEffectivenessBand.THIRTY]: band30,
    },
    totalRecords,
  };
};

export default computeOverdueBands;
